


















import { defineComponent, PropType } from '~/utils/nuxt3-migration'
import CTimeInput from '~/components/shared/configurable/datetime/CTimeInput.vue'
import CConfirmationModal from '~/components/shared/configurable/modal/CConfirmationModal.vue'
import CTextArea from '~/components/shared/configurable/form/input/CTextArea.vue'
import AuditAppointmentForm from '~/components/shared/audits/request/AuditAppointmentForm.vue'
import { StripePayment } from '~/models/payments/stripe'
import CancelAuditButton from '~/components/shared/audits/request/timeline/CancelAuditButton.vue'
import { ciWallet } from '~/icons/source/solid/wallet'
import { AuditRequest } from '~/models/audit/request'

export default defineComponent({
  components: {
    CancelAuditButton,
    CTextArea,
    CTimeInput,
    CConfirmationModal,
    AuditAppointmentForm
  },
  props: {
    auditRequest: {
      type: Object as PropType<AuditRequest>,
      required: true
    },
    payment: {
      type: Object as PropType<StripePayment>,
      required: true
    }
  },
  setup() {
    return {
      ciWallet
    }
  }
})
